module.exports = __webpack_public_path__ + "static/media/celebration.44f977ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/celebration.svg
// module id = 1385
// module chunks = 0